module.exports = __webpack_public_path__ + "static/media/Multinational-Companies-Disputes.ea966710.jpg";